




































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */
import { Vue, Component, Prop } from "vue-property-decorator";
import { OrderActions } from "@/store/modules/order/types";
import { StoreModule } from "@/store/types";
import { namespace } from "vuex-class";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { PriceLevel } from "@/models/netsuite/netsuite";
import { priceLevelMultiplier } from "@/utility/helpers";
@Component
export default class ConfirmClearCustomer extends Vue {
  @(namespace(StoreModule.Order).Action(OrderActions.ClearCustomer))
  clearCustomer!: () => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  clearOrder!: () => Promise<void>;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.ApplyQuoteMultiplier))
  applyQuoteMultiplier!: (value: number) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetPriceLevels))
  storePriceLevels!: PriceLevel[];

  protected closeModal(): void {
    this.$emit("close");
  }

  protected async removeCustomer(): Promise<void> {
    await this.clearCustomer();
    const baseLevel = this.storePriceLevels.find(l => l.id === 1) ?? null;
    await this.addMultiplier(baseLevel);
    // The cart is kept here (only the customer is dropped), so its lines are
    // re-priced at Base Price now — the cart's mount-time stamp no longer
    // re-prices a deliberately mixed cart.
    if (baseLevel) {
      await this.applyQuoteMultiplier(priceLevelMultiplier(baseLevel.discountpct));
    }
    this.$emit("close");
  }

  protected async clearAll(): Promise<void> {
    this.$emit("clearOrder");
    await this.clearOrder();
    await this.clearCustomer();
    const baseLevel = this.storePriceLevels.find(l => l.id === 1) ?? null;
    await this.addMultiplier(baseLevel);
    this.$emit("close");
  }
}
